/* UtilCookie util */
export default class UtilCookie {
    /**
     * Available default days
     * @return {number}
     */
    static get days() {
        // eslint-disable-next-line no-magic-numbers
        return 30;
    }
    /**
     * Check cookie existence
     *
     * @param {string} name
     * @return {boolean}
     */
    isSet(name) {
        return document.cookie.split(';').some((item) => item.trim().startsWith(name + '='));
    }
    /**
     * Get a cookie value
     *
     * @param {string} name
     * @return {string} If returns "undefined" if a non-existing cookie is requested
     */
    getCookie(name) {
        if (this.isSet(name)) {
            const pattern = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$');
            return document.cookie.replace(pattern, '$1');
        }
        return undefined;
    }
    /**
     * Set a cookie
     *
     * @param {string} name
     * @param {string} value
     * @param {string} path
     * @param {number|null} days time range in days (default 30)
     * @return {boolean}
     */
    setCookie(name, value, path = '', days = UtilCookie.days) {
        const valueStr = name + '=' + value;
        const pathStr = path ? '; path=' + path : '';
        let expireStr = '';
        if (days != null) {
            const expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + days);
            expireStr = '; expires=' + expireDate.toUTCString();
        }
        document.cookie = valueStr + expireStr + pathStr;
        return this.isSet(name);
    }
    deleteCookie(name, path, domain) {
        if (this.isSet(name)) {
            document.cookie =
                name +
                    '=' +
                    (path ? ';path=' + path : '') +
                    (domain ? ';domain=' + domain : '') +
                    ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
        }
    }
}
